<template>
  <div class="container">
    <el-card class="card" shadow="never">
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        inline
        label-suffix="："
        style="margin-top: 22px"
      >
        <el-form-item
          label="Customer ID / Customer Name"
          prop="companyCode"
          label-width="260px"
          style="margin-right: 80px"
        >
          <el-select
            v-model="form.companyCode"
            filterable
            remote
            reserve-keyword
            :remote-method="remoteCode"
            style="width: 450px"
            @change="_selectChange"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- </el-form-item> -->
          <!--        <el-form-item label="Customer Name" style="margin-bottom: 0">-->
          <!--          <span class="activeName" id="activeName" ref="activeName" />-->
          <!--        </el-form-item>-->
          <!-- <el-form-item> -->
          <customize-button type="primary" @click="handleNext">
            Next
          </customize-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { vagueQuery } from './api'

export default {
  name: 'home',
  data() {
    const rules = {
      companyCode: [
        {
          required: true,
          message: 'Must can not be empty!',
          trigger: 'change',
        },
      ],
    }
    return {
      rules,
      form: {
        companyCode: '',
        companyName: '',
      },
      options: [], // 模糊查询options
      source: '',
    }
  },
  methods: {
    handleNext() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.source === 2) {
            this.$router.push(
              `/credit-management/css-request/${this.form.companyCode}/detail`,
            )
            return
          }
          this.$router.push(
            `/credit-management/credit-request/${this.form.companyCode}/detail`,
          )
        }
      })
    },
    customerType(val) {
      if (val === 1) {
        return 'Trade'
      } else if (val === 2) {
        return 'Eaas'
      } else if (val === 3) {
        return 'Saas'
      }
    },
    // 模糊查询code
    async remoteCode(query) {
      if (query !== '') {
        try {
          const params = {
            name: query,
          }
          const res = await vagueQuery(params)
          this.options = res.map(item => ({
            id: item.id,
            label: item.code,
            value: item.id,
            name: `${item.name} ${
              item.customerType !== 4
                ? `- ${this.customerType(item.customerType)}`
                : ''
            }`,
            source: item.source || '',
          }))
        } catch (err) {
          console.log(err)
        }
      } else {
        this.options = []
      }
    },
    _selectChange(val) {
      // const _name = this.options.filter(item => item.id === val)[0].name
      this.source = this.options.filter(item => item.id === val)[0].source
      // document.getElementById('activeName').innerText = _name
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  display: flex;
  .card {
    width: 100%;
  }
  .customize-button {
    margin-left: 30px;
  }
  .activeName {
    display: inline-block;
    width: 300px;
    height: 40px;
    //border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-sizing: border-box;
    padding-left: 14px;
    //cursor: not-allowed;
    overflow: hidden;
  }
}
</style>
